import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { Modal } from 'react-bootstrap';
import { observer } from 'mobx-react/index';
import Validatorjs from 'validatorjs';
import Notifications from '../utils/notification-helper';

/**
 * Assumes appStore.tcFile.selected file is not null
 */
@inject('appStore')
@observer
export default class AgentPreferredEmailModal extends Component {
    constructor(props) {
        super(props);
        this.state = { formError: null, preferredEmail: '' };
    }

    handleShow() {
        this.props.appStore.agentProfileStore
            .getAgentProfileByContactId(
                _.first(this.props.appStore.tcFileStore.selectedFileViewModel.agents).agentContactId
            )
            .then(agentProfile => {
                this.setState({ formError: null, agentProfile: agentProfile });
            });
    }

    savePreferredEmail() {
        //disable save button to not let user click more than once.
        document.getElementById('btnSavePreferredEmail').disabled = true;
        //Validation
        const agent = _.first(this.props.appStore.tcFileStore.selectedFileViewModel.agents);
        const validation = new Validatorjs(
            { preferredEmail: this.state.preferredEmail },
            { preferredEmail: ['required','regex:/^([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}(,|$))+$/'] }
        );
        validation.setAttributeNames({ preferredEmail: 'preferred email' });
        if (validation.passes()) {
            //Use existing profile
            const agentProfile = _.clone(this.state.agentProfile);
            agentProfile.agentContactId = agent.agentContactId;
            agentProfile.preferredEmail = this.state.preferredEmail;

            //Save or Create an Agent Profile
            this.props.appStore.agentProfileStore
                .saveAgentProfile(agentProfile, ['agentContactId', 'preferredEmail', 'agentProfileId'])
                .then(({ body }) => {
                    Notifications.ToastSuccess(
                        `${agent.name} preferred email has been set to: ${body.preferredEmail}.`
                    );

                    this.props.handlePreferredEmailSave(body);
                    this.props.appStore.viewStore.hidePreferredEmailDialog();
                })
                .catch(err => {
                    document.getElementById('btnSavePreferredEmail').disabled = false;
                    console.log(err);
                    Notifications.ToastError('Error saving Preferred Email for agent');
                });
        } else {
            document.getElementById('btnSavePreferredEmail').disabled = false;
            this.setState({ formError: validation.errors.errors['preferredEmail'] });            
        }
    }

    render() {
        if (!this.props.appStore.tcFileStore.selectedFileViewModel) return null;

        const agentEmail = this.props.appStore.tcFileStore.selectedFileViewModel.agents[0].email;
        return (
            <Modal
                show={appStore.viewStore.preferredEmailDialogOpen}
                onShow={this.handleShow.bind(this)}
                onHide={appStore.viewStore.hidePreferredEmailDialog}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-lg">Preferred Email</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <form>
                            {/*Preferred Email a*/}
                            <div className="form-group">
                                <label htmlFor="model-preferredEmail">Agent Preferred Email</label>
                                <input
                                    id="model-preferredEmail"
                                    type="text"
                                    className="form-control"
                                    value={this.state.preferredEmail}
                                    onKeyPress={event => {
                                        if (event.which === 13 /* Enter */) {
                                            event.preventDefault();
                                        }
                                    }}
                                    onChange={e => {
                                        this.setState({ preferredEmail: e.currentTarget.value });
                                    }}
                                />
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    style={{ marginTop: 5 }}
                                    onClick={() => {
                                        this.setState({ preferredEmail: agentEmail });
                                    }}
                                >
                                    Use: {agentEmail}
                                </button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <p
                        className="pull-left"
                        style={{
                            color: 'red',
                            display: this.state.formError ? 'block' : 'none',
                        }}
                    >
                        {this.state.formError}
                    </p>
                    <button
                        id="btnSavePreferredEmail"
                        type="button"
                        className="btn btn-primary pull-right"
                        onClick={this.savePreferredEmail.bind(this)}
                    >
                        Save
                    </button>
                    <button                        
                        type="button"
                        className="btn btn btn-default pull-right"
                        style={{ marginRight: 10 }}
                        onClick={() => (appStore.viewStore.preferredEmailDialogOpen = false)}
                    >
                        Cancel
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/agents/agent-preferred-email-modal.js